import { Channel, dayTime, postTime, ReachPost } from './reach';

/**
 * A post an approval link names, and what the Approvals review says when it no
 * longer waits (the link outlived the decision).
 */
export type ApprovalPost = ReachPost & {
  accountId: string;
  reviewNote?: string | null;
  reviewedAt?: string | null;
  account?: { id: string; name: string } | null;
  socialProfile?: Channel | null;
};

export const MAX_NOTE = 1000;

/** What the review says when the post no longer waits on the person. */
export function approvalOutcome(post: ApprovalPost): { title: string; text: string } | null {
  const at = postTime(post);
  const when = at ? dayTime(at) : null;
  switch (post.reachStatus) {
    case 'waiting':
      return null;
    case 'posted':
      return { title: 'This post went out', text: when ? `It went out ${when}.` : 'It went out.' };
    case 'publishing':
      return { title: 'This post is going out', text: 'It’s on its way to the channel now.' };
    case 'scheduled':
      return {
        title: post.reviewStatus === 'approved' ? 'Approved' : 'Scheduled',
        text: when ? `It goes out ${when}.` : 'It goes out soon.',
      };
    case 'skipped':
      return { title: 'Skipped', text: 'It won’t go out.' };
    case 'missed':
      return {
        title: 'This post didn’t go out',
        text: 'Open it in the calendar to try again or skip it.',
      };
    default:
      // A draft: sent back with a note, or saved without a time.
      return post.reviewNote
        ? {
            title: 'Sent back for changes',
            text: 'Your agent can change it and send you a new link to approve.',
          }
        : { title: 'This post is a draft', text: 'It won’t go out until it’s scheduled.' };
  }
}
